'use client';

import { useTranslation } from 'react-i18next';
import { Heading4, Title2 } from 'components/Typography';
import { BaseLayout } from 'structure/Layouts/SFILayouts/BaseLayout/BaseLayout';
import { EcosystemDapp } from 'components/EcoSystem/ExploreDapp';

export default function Ecosystem() {
  const { t } = useTranslation('ecosystem');

  return (
    <BaseLayout>
      <div className='flex flex-col items-center'>
        <Title2 className='pb-3 text-xl leading-tight text-white md:text-[52px]'>
          {t('ECOSYSTEM')}
        </Title2>
        <Heading4 className='pb-4 text-center font-light text-white'>
          {t('ECOSYSTEM_SUBTITLE')}
        </Heading4>
      </div>
      <EcosystemDapp />
    </BaseLayout>
  );
}
